import React from 'react';
import {Location} from '@remix-run/router';
import HeaderInvoiceList from '../components/HeaderInvoiceList';
import {Consumer} from '../../enum/ConsumerEnum';
import {InitPaymentSelectorParams, IPaymentService} from '../../services/IPaymentService';
import PlatformEndpointHelper from '../../utils/FSPlatformEndpointHelper';
import {paymentErrorPage} from '../components/PaymentErrorPage';
import FooterInvoice from '../components/FooterInvoice';
import queryString from 'query-string';
import _ from 'lodash';
import {IAnalyticsService} from '../../services/IAnalyticsService';
import {EventName} from '../../enum/AnalyticsEnum';
import {HeaderFooterInvoice} from '../components/HeaderInvoice';

export interface PayInvoiceListProps {
    readonly getBulkPaymentRecord: IPaymentService['getBulkPaymentRecord'];
    readonly initPaymentSelector: IPaymentService['initPaymentSelector'];
    readonly params?: any;
    readonly useLocation?: Location;
    readonly navigateToPage?: (link: string) => void;
    readonly notifyEvent: IAnalyticsService['notifyEvent'];
}

export class PayInvoiceList extends React.Component<PayInvoiceListProps, any> {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            isPaymentPage: true,
            isStatement: false,
            recording: false,
            invoicesToPay: 0,
            isTimeout: false,
            bulkPaymentError: false
        };
    }

    userActionHistory: string[] = [];

    renderBulkPaymentSelector = () => {
        const {bulkPaymentRecord, fsPlatformError, error} = this.state;

        if (fsPlatformError || error) {
            return paymentErrorPage({
                cancelPayment: this.cancelPayment,
                isSinglePaymentError: false,
                errorType: fsPlatformError ? 'errorInitFsPaymentSelector' : 'errorGettingBulkPayment',
                errorTracking: this.errorTracking
            });
        }

        if (!bulkPaymentRecord) {
            return <div/>;
        }

        const {loading, isPotentialFSClient, selector} = this.state;
        return (
            !loading && <div className="container">
                <div className="row">
                    <div className={'pay-ui' + (isPotentialFSClient ? ' fs-payment-container' : '')}>
                        {
                            isPotentialFSClient &&
                            <div>
                                <div id="close-payment-modal"
                                     onClick={() => {
                                         this.cancelPayment();
                                     }}
                                     className="cancel-pay icon-remove fs-cancel-button"
                                />
                                <h2 className="text-center">Payment method</h2>
                                <iframe src={selector.selectorURL} id="paymentOptions"
                                        className="fs-payment-options" scrolling="no" allow="payment"/>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    };

    notifyCloseEvent = () => {
        const { bulkPaymentRecord } = this.state;
        const { useLocation, notifyEvent } = this.props;
        const search = _.get(useLocation, 'search', '')
        const query = queryString.parse(search);
        const source = _.get(query, 'source', '');

        const activityData = {
            bulkPaymentRecord: bulkPaymentRecord,
            paymentMethod: 'none',
            invoiceListId: bulkPaymentRecord.id,
            source: source
        };
        notifyEvent(EventName.CLOSE_PAY_BUTTON, activityData, true);
    };

    render() {
        const {
            loading,
            isPaymentPage,
            isStatement,
            recording,
            invoicesToPay,
            totalDue,
            isTimeout,
            bulkPaymentError,
            invoiceList,
            selector,
            fsPlatformError
        } = this.state;
        return (
            <>
                <HeaderInvoiceList error={false}
                                   loading={loading}
                                   showListPage={this.showListPage(fsPlatformError, bulkPaymentError)}
                                   isStatement={isStatement}
                                   isPaymentPage={isPaymentPage}
                                   recording={recording}
                                   invoicesToPay={invoicesToPay}
                                   invoiceList={invoiceList}
                                   totalDue={totalDue}
                                   isTimedOut={isTimeout}
                                   bulkPaymentError={bulkPaymentError}
                                   fsPlatformError={false}
                />
                {this.renderBulkPaymentSelector()}
                {this.shouldShowFooter(selector) && <FooterInvoice country={'AU'}/>}
                <HeaderFooterInvoice
                    loading={loading}
                    recording={recording}
                    error={false}
                    invoice={invoiceList}
                />

            </>
        );
    }

    componentDidUpdate(prevProps) {
        if (prevProps.params != this.props.params) {
            this.setState({
                ...this.state,
                loading: true
            })
            this.getBUlkPayment();
        }
    }

    componentDidMount() {
        this.getBUlkPayment();
    }

    getBUlkPayment = () => {
        const {
            params: {bulkPaymentId},
            getBulkPaymentRecord,
            useLocation,
            initPaymentSelector
        } = this.props;
        getBulkPaymentRecord(bulkPaymentId)
            .then(bulkPaymentDetails => this.setBulkPaymentRecord(bulkPaymentDetails))
            .then(bulkPaymentRecord => {
                this.notifyPayViewInvoice(bulkPaymentRecord);
                return Promise.resolve(bulkPaymentRecord);
            })
            .then(bulkPaymentRecord => this.setPaymentSelectorInfo(bulkPaymentRecord, useLocation, initPaymentSelector))
            .catch(this.onError);
    }

    onError = () => {
        this.setState((state) => ({
            ...state,
            loading: false,
            error: true,
            bulkPaymentError: true,
            isPotentialFSClient: true
        }));
    };

    private shouldShowFooter = (selector) => {
        return !selector;
    };

    private setPaymentSelectorInfo = (bulkPaymentRecord, useLocation: Location | undefined, initPaymentSelector: (params: InitPaymentSelectorParams) => Promise<any>) => {
        if (bulkPaymentRecord.status === 'INITIALIZED') {
            this.userActionHistory.push('bulk-init-payment-selector');
            const {clientId, crn} = this.getClientIdAndBpayCRN(bulkPaymentRecord);
            const bulkPaymentRecordId = bulkPaymentRecord.id;
            const search = _.get(useLocation, 'search', '')
            const query = queryString.parse(search);
            const source = _.get<any, any, string>(query, 'source', '');
            const company = bulkPaymentRecord.company;
            const businessId = bulkPaymentRecord.consumer === Consumer.ARL ? company.uid : company.serialNumber;
            const enabledPaymentOptions = bulkPaymentRecord.paymentConfigs.map(config=> config.type)
            if (_.includes(enabledPaymentOptions,'creditCard')){
                enabledPaymentOptions.push('applePay')
                enabledPaymentOptions.push('googlePay')
            }
            const initParams: InitPaymentSelectorParams = {
                isBulk: true,
                clientId,
                clientReportRef: bulkPaymentRecord.id,
                clientRef: bulkPaymentRecordId,
                crn,
                businessId,
                currency: bulkPaymentRecord.currency,
                totalAmount: bulkPaymentRecord.totalAmount,
                invoiceHash: bulkPaymentRecordId,
                source,
                invoiceLineItems: _.get(bulkPaymentRecord,'invoiceLineItems',[]),
                enabledPaymentOptions: enabledPaymentOptions
            };
            initPaymentSelector(initParams)
                .then((fsPlatformInfo) => {
                    this.setState((state) => ({
                        ...state,
                        fsPlatformError: fsPlatformInfo.hasError,
                        isPotentialFSClient: fsPlatformInfo.isPotentialFSClient
                    }));

                    if (fsPlatformInfo.isPotentialFSClient && !fsPlatformInfo.hasError) {
                        PlatformEndpointHelper.appendScriptFromPlatformEndpoint(fsPlatformInfo);
                        this.setState((state) => ({
                            state,
                            selector: fsPlatformInfo.selector
                        }));
                    }
                })
                .catch(() => {
                    this.setState((state) => ({
                        state,
                        isPotentialFSClient: true, fsPlatformError: true
                    }));
                });

        } else {
            return Promise.reject();
        }
    };

    showListPage = (fsPlatformError, bulkPaymentError) => {
        return !fsPlatformError &&
            !bulkPaymentError;
    };

    setBulkPaymentRecord = (bulkPaymentRecord: any) => {
        const record: any = {};
        record.bulkPaymentRecord = bulkPaymentRecord;
        record.invoiceList = {
            companyName: bulkPaymentRecord.company.name,
            customerEmail: bulkPaymentRecord.customer.email,
            customerName: bulkPaymentRecord.customer.name,
            invoiceListCurrency: bulkPaymentRecord.currency
        };
        record.isStatement = bulkPaymentRecord.isStatement || false;
        record.totalDue = bulkPaymentRecord.totalAmount;
        record.invoicesToPay = bulkPaymentRecord.invoices.length;
        this.setState((state) => ({
            ...state,
            ...record,
            loading: false,
            invoicesToPay: bulkPaymentRecord.invoices.length
        }));
        return Promise.resolve(record.bulkPaymentRecord);
    };

    getClientIdAndBpayCRN = (bulkPaymentRecord): any => {
        if (!bulkPaymentRecord) {
            return null;
        }
        const paymentConfigs = bulkPaymentRecord.paymentConfigs || [];

        const bpayOptions = paymentConfigs.filter(option => option.type === 'bpay');
        const creditCardOptions = paymentConfigs.filter(option => option.type === 'creditCard');
        if (creditCardOptions.length < 1) {
            return null;
        }
        const clientId = creditCardOptions[0].client_id;
        const crn = bpayOptions.length > 0 ? bpayOptions[0].reference_number : null;

        if (!clientId) {
            return {clientId: null, crn};
        }
        return {clientId, crn};
    };

    cancelPayment = () => {
        const {navigateToPage, useLocation, params} = this.props;
        this.notifyCloseEvent();
        navigateToPage && navigateToPage(`/invoicelist/${params.invoiceListId}${useLocation?.search ? useLocation.search : ''}`);
    };

    notifyPayViewInvoice = (bulkPaymentRecord: any) => {
        const { notifyEvent, useLocation } = this.props;
        const search = _.get(useLocation, 'search', '')
        const query = queryString.parse(search);
        const source = _.get(query, 'source', '');

        const activityData = {
            bulkPaymentRecord: bulkPaymentRecord,
            paymentMethod: 'undefined',
            source: source,
            invoiceId: bulkPaymentRecord.id
        };
        notifyEvent(EventName.PAY_VIEW_INVOICE, activityData, true);
    };

    errorTracking = (errorType: string) => {
        const {useLocation, notifyEvent} = this.props;
        const bulkPaymentRecord = this.state.bulkPaymentRecord;
        if (!bulkPaymentRecord) return;
        const search = _.get(useLocation, 'search', '')
        const query = queryString.parse(search);
        const source = _.get(query, 'source', '');
        const userId = bulkPaymentRecord.consumer + '/' + bulkPaymentRecord.company.uid;
        const activityData = {
            userId,
            companyId: bulkPaymentRecord.company.uid,
            consumer: bulkPaymentRecord.consumer,
            source: source,
            history: this.userActionHistory,
            customerId: bulkPaymentRecord.customer.id,
            errorType: errorType,
            invoiceListCount: bulkPaymentRecord.invoices.length
        };
        notifyEvent('invoice-list-error', activityData);
    };
}
